import { ModulesMap } from '@/config/data/modulesMaps'

import cacheDtConfig from './cacheDtConfig'
import userDtConfig from './userDtConfig'
import companyDtConfig from './companyDtConfig'
import authDtConfig from './authDtConfig'
import presetsDtConfig from './presetsDtConfig'
import mapsDtConfig from './mapsDtConfig'

export default {
	[ModulesMap.CACHE]: cacheDtConfig,
	[ModulesMap.USER]: userDtConfig,
	[ModulesMap.COMPANY]: companyDtConfig,
	[ModulesMap.AUTH]: authDtConfig,
	[ModulesMap.PRESETS]: presetsDtConfig,
	[ModulesMap.MAPS]: mapsDtConfig,
}
